import Vue from "vue";
import CommonVarchar from "./CommonVarchar.vue";
export default Vue.extend({
    components: {
        CommonVarchar,
    },
    props: {
        modelValue: {
            type: String,
            default: undefined,
        },
        autocomplete: {
            type: String,
            default: "off",
        },
        id: {
            type: String,
            default: "",
        },
        fieldType: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        hideLabel: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        state: {
            type: Boolean,
            default: null,
        },
        name: {
            type: String,
            default: "",
        },
        placeholder: {
            type: String,
            default: "",
        },
        description: {
            type: String,
            default: "",
        },
        validationErrors: {
            type: String,
            default: "",
        },
    },
    methods: {
        handleInput(event) {
            this.$emit("input", event);
        },
    },
});
